import React from 'react';
import PropTypes from 'prop-types';

// Components
import GasSectionCardShell from '../GasSectionCardShell/GasSectionCardShell';
import ExpandableThumbnail from '../../../layout/components/ExpandableThumbnail/ExpandableThumbnail';
import PhotoStrip from './components/PhotoStrip';

const GasPictureRow = ({section, gas, documents}) => (
  <GasSectionCardShell section={section} gas={gas}>
    {!!documents.length && (
      <PhotoStrip>
        {documents.map((doc) => (
          <ExpandableThumbnail key={doc.id} src={doc.src} label={doc.label} />
        ))}
      </PhotoStrip>
    )}
  </GasSectionCardShell>
);

GasPictureRow.propTypes = {
  section: PropTypes.object.isRequired,
  gas: PropTypes.object,
  documents: PropTypes.array,
};

GasPictureRow.defaultProps = {
  documents: [],
};

export default GasPictureRow;
